'use client';

import classNames from 'classnames';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { ThemeConfigurator } from './ThemeConfigurator';
import { menu } from './menu';

export function Header() {
  const pathname = usePathname();
  const [displayMobileNavbar, setDisplayMobileNavbar] = useState(false);

  const isOnPath = (path: string) => (pathname === path ? 'active' : undefined);
  const handleToggle = () => setDisplayMobileNavbar((prev) => !prev);

  return (
    <header className="header-area">
      <div className="container">
        <div className="gx-row d-flex align-items-center justify-content-between">
          <Link href="/" className="logo">
            <img src="/assets/logo/logo.png" alt="Logo" />
          </Link>
          <nav className={classNames('navbar', { active: displayMobileNavbar })}>
            <ul className="menu">
              {menu.map((entry, i) => (
                <li className={isOnPath(entry.path)} key={i}>
                  <Link href={entry.path} onClick={handleToggle}>
                    {entry.label}
                  </Link>
                </li>
              ))}
            </ul>
            <a
              className="theme-btn"
              href="https://calendly.com/devmtnali/30min"
              target="_blank"
              rel="noreferrer noopener"
            >
              <span role="img" aria-label="coffee">
                ☕
              </span>{' '}
              Chat with Ali
            </a>
          </nav>

          <ThemeConfigurator />
          <div
            className={classNames('show-menu', { active: displayMobileNavbar })}
            onClick={handleToggle}
          >
            <span />
            <span />
            <span />
          </div>
        </div>
      </div>
    </header>
  );
}
